import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails, Typography } from '@mui/material';
import { Accordion } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Grid } from '@mui/material';
import { memo, useState } from 'react';
import Form from './form';
import { SubjectIcaroVM } from 'civil-status/view-models/form-declaration-icaro';
import { FormikErrors, FormikTouched } from 'formik';
import FormBorn from './form-born';

interface SubjectIcaroProps {
  disabled?: boolean;
  values?: SubjectIcaroVM;
  errors?: FormikErrors<SubjectIcaroVM>;
  touched?: FormikTouched<SubjectIcaroVM>;
  onChange: (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => void;
  isDeclarant?: boolean;
  isBorn?: boolean;
  title: string;
}
const SubjectIcaroComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
  isDeclarant = false,
  isBorn = false,
  title,
}: SubjectIcaroProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls={`panel-data-declaration-content`}
        id={`panel-data-declaration-header`}
        expandIcon={<ExpandMore />}
      >
        <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {open ? (
          <Grid item container spacing={2}>
            {isBorn ? (
              <FormBorn
                disabled={disabled}
                values={values}
                errors={errors}
                touched={touched}
                onChange={onChange}
              />
            ) : (
              <Form
                disabled={disabled}
                values={values}
                errors={errors}
                touched={touched}
                onChange={onChange}
                isDeclarant={isDeclarant}
              />
            )}
          </Grid>
        ) : undefined}
      </AccordionDetails>
    </Accordion>
  );
};

SubjectIcaroComponent.displayName = 'Subject Icaro Component';

const SubjectIcaro = memo(SubjectIcaroComponent);

export default SubjectIcaro;
